import { createActions, handleActions } from 'redux-actions';
import constants from 'src/constants';
import selectors from './selectors';

const { SPLIT_MODES } = constants.app;

const initialState = {
  isDeletingSplit: false,
  isEditingSplit: false,
  isSplitToolActive: false,
  splitToolMaxOffset: 0,
  splitToolMinOffset: 0,
  splitToolNodes: [],
  splitToolOrientation: SPLIT_MODES.HORIZONTAL,
  splitPercentage: 0.5,
};

const CHANGE_SPLIT_TOOL_ORIENTATION =
  'DESIGN_PRO/SPLIT/CHANGE_SPLIT_TOOL_ORIENTATION';
const HANDLE_DELETE_SPLIT_CLICK = 'DESIGN_PRO/SPLIT/HANDLE_DELETE_SPLIT_CLICK';
const HANDLE_CANCEL_DELETE_SPLIT =
  'DESIGN_PRO/SPLIT/HANDLE_CANCEL_DELETE_SPLIT';
const HANDLE_CONFIRM_DELETE_SPLIT =
  'DESIGN_PRO/SPLIT/HANDLE_CONFIRM_DELETE_SPLIT';
const HANDLE_SPLIT_TOOL_CANCEL_SPLIT =
  'DESIGN_PRO/SPLIT/HANDLE_SPLIT_TOOL_CANCEL_SPLIT';
const HANDLE_SPLIT_TOOL_CLICK = 'DESIGN_PRO/SPLIT/HANDLE_SPLIT_TOOL_CLICK';
const HANDLE_SPLIT_TOOL_CONFIRM_SPLIT =
  'DESIGN_PRO/SPLIT/HANDLE_SPLIT_TOOL_CONFIRM_SPLIT';
const HANDLE_SPLIT_TOOL_OFFSET_CHANGE =
  'DESIGN_PRO/SPLIT/HANDLE_SPLIT_TOOL_OFFSET_CHANGE';
const SET_SPLIT_TOOL_OFFSET_RANGE =
  'DESIGN_PRO/SPLIT/SET_SPLIT_TOOL_OFFSET_RANGE';

const actions = createActions({
  [CHANGE_SPLIT_TOOL_ORIENTATION]: (orientation) => ({ orientation }),
  [HANDLE_DELETE_SPLIT_CLICK]: () => null,
  [HANDLE_CONFIRM_DELETE_SPLIT]: () => null,
  [HANDLE_CANCEL_DELETE_SPLIT]: () => null,
  [HANDLE_SPLIT_TOOL_CANCEL_SPLIT]: () => null,
  [HANDLE_SPLIT_TOOL_CLICK]: ({ nodes, isEditing }) => ({ nodes, isEditing }),
  [HANDLE_SPLIT_TOOL_CONFIRM_SPLIT]: () => null,
  [HANDLE_SPLIT_TOOL_OFFSET_CHANGE]: (splitPercentage) => ({ splitPercentage }),
  [SET_SPLIT_TOOL_OFFSET_RANGE]: ({ minOffset, maxOffset }) => ({
    minOffset,
    maxOffset,
  }),
});

const reducer = handleActions(
  {
    [actions.designPro.split.changeSplitToolOrientation]: (state, action) => ({
      ...state,
      splitToolOrientation: action.payload.orientation,
    }),
    [actions.designPro.split.handleDeleteSplitClick]: (state) => ({
      ...state,
      isDeletingSplit: true,
    }),
    [actions.designPro.split.handleConfirmDeleteSplit]: (state) => ({
      ...state,
      isDeletingSplit: false,
      isSplitToolActive: false,
      isEditingSplit: false,
    }),
    [actions.designPro.split.handleCancelDeleteSplit]: (state) => ({
      ...state,
      isDeletingSplit: false,
    }),
    [actions.designPro.split.handleSplitToolCancelSplit]: (state) => ({
      ...state,
      isSplitToolActive: false,
      isEditingSplit: true,
      splitToolNodes: [],
      splitToolOrientation: null,
    }),
    [actions.designPro.split.handleSplitToolClick]: (state, action) => ({
      ...state,
      isSplitToolActive: true,
      isEditingSplit: action.payload.isEditing,
      splitToolNodes: action.payload.nodes,
      splitToolOrientation: SPLIT_MODES.HORIZONTAL,
    }),
    [actions.designPro.split.handleSplitToolConfirmSplit]: (state) => ({
      ...state,
      isSplitToolActive: false,
      isDeletingSplit: false,
    }),
    [actions.designPro.split.setSplitToolOffsetRange]: (state, action) => ({
      ...state,
      splitToolMaxOffset: action.payload.maxOffset,
      splitToolMinOffset: action.payload.minOffset,
    }),
    [actions.designPro.split.handleSplitToolOffsetChange]: (state, action) => ({
      ...state,
      splitPercentage: action.payload.splitPercentage,
    }),
  },
  initialState,
);

export default {
  initialState,
  actions: actions.designPro.split,
  reducer,
  selectors,
};
